import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { VsiH6, VsiP } from "../styled/App.styled";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";

function Dropzone ({ onDrop, className, style, noClick, noDrag, children, fileType={'application/zip': ['.zip']}}) {
    const { getRootProps, getInputProps, isDragActive, fileRejections } = useDropzone({
        // accept type is default to zip, use csv for BU
        accept: fileType,
        onDrop,
        noClick: noClick ? true : false,
        noDrag: noDrag ? true : false,
        maxFiles: 50,
        maxSize: 1073741824 // 1 GB
    });

    const [fileTypeErr, setFileTypeErr] = useState(false);
    const [fileSizeErr, setFileSizeErr] = useState(false);
    const [fileAmtErr, setFileAmtErr] = useState(false);
    const [fileOtherErr, setFileOtherErr] = useState(false);

    useEffect(() => {
        setFileTypeErr(false);
        setFileSizeErr(false);
        setFileAmtErr(false);
        setFileOtherErr(false);
        
        if(fileRejections.filter(rejection => rejection.errors[0].code === "file-invalid-type").length > 0) {
            setFileTypeErr(true);
        } else if (fileRejections.filter(rejection => rejection.errors[0].code === "file-too-large").length > 0) {
            setFileSizeErr(true);
        } else if (fileRejections.filter(rejection => rejection.errors[0].code === "too-many-files").length > 0) {
            setFileAmtErr(true);
        } else if (fileRejections.length > 0) {
            setFileOtherErr(true);
        };
    }, [fileRejections]);

    const fileRejectionType = fileTypeErr ? 
        " Only ZIP type files are accepted." : null

    const fileRejectionSize = fileSizeErr ? 
        "File size is too large." : null
        
    const fileRejectionNum = fileAmtErr ? 
        "Maximum of 20 files per upload." : null
        
    const fileRejectionOther = fileOtherErr ? 
        "Something went wrong." : null

    return (
        <div className={className} >
            <div {...getRootProps({ className: "dropzone" })} style={style}>
                <input className="input-zone"{...getInputProps()} />
                <div className="text-center">
                    {!noDrag ? 
                        (isDragActive ? (
                            <VsiP className="dropzone-content">
                                Release here to drop the files.
                            </VsiP>
                        ) : (
                            <VsiP className="dropzone-content">
                                Drag and drop here, or click to select files.
                                <br />
                                Maximum of 20 files per upload.
                            </VsiP>
                        ))
                    : null}
                </div>
                {fileRejections.length > 0 ?
                    <VsiH6 className="bg-danger p-2 mb-5 mt-5">
                        {fileRejectionType}
                        {fileRejectionSize}
                        {fileRejectionNum}
                        {fileRejectionOther}
                    </VsiH6> : null}
                <br />
                {children}
            </div>
        </div>
    );
}

export default withErrorBoundary(Dropzone, GeneralErrorBoundary);
